const getters = {
    bankStatement: (state) => state.bankStatement,
    loading: state => state.loading
};

export default getters;